import { createTheme } from '@mui/material/styles';

import { palette } from './palette';
import typography from './typography';

export const MuiTheme = createTheme({
    spacing: 4,
    palette,
    shape: { borderRadius: 4 },
    typography: {
        fontFamily: "'Poppins', sans-serif",
        fontSize: 16,
        htmlFontSize: 16,
        ...typography,
    },
    components: {
        MuiTypography: {
            defaultProps: {
                variantMapping: {
                    h7: 'h6',
                    h8: 'h6',
                    h9: 'h6',
                },
            },
        },
    },
    zIndex: {
        modal: 999,
        appBar: 1500,
        snackbar: 2000,
    },
});
